<template>
  <div id="branchMoodReportPage">
    <vs-table
      id="branchMoodReport"
      ref="table"
      :data="moodTransactions"
      :max-items="itemsPerPage"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-dark xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != '' && chip.name"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-3/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'customer.Email' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('customer.Email')"
            >Kullanıcı Email
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'type' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('type')"
            >Tip
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'product.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('product.Name')"
            >Ürün
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'quantity' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('quantity')"
            >Adet
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'amount' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('amount')"
            >Maaliyet
          </vs-button>
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-3/12">
              <p class="text-center">{{ tr.customer.name }}</p>
            </vs-td>
            <vs-td class="w-2/12">
              <p v-if="tr.type == 0" class="text-center text-success">
                Kazanma
              </p>
              <p v-else-if="tr.type == 1" class="text-center text-danger">
                Harcama
              </p>
            </vs-td>
            <vs-td class="w-3/12">
              <p v-if="tr.product" class="text-center">{{ tr.product.name }}</p>
              <p v-else-if="tr.type == 0" class="text-center text-warning">
                Referans Daveti
              </p>
            </vs-td>
            <vs-td class="w-2/12">
              <p class="text-center">{{ tr.quantity }}</p>
            </vs-td>
            <vs-td class="w-2/12">
              <p class="text-center">{{ $toCurrency(tr.amount) }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import PaginationDefault from "../../PaginationDefault";
import GlobalFilter from "../../GlobalFilter";
import {
  GetBranchMoodTransactions,
  GetBranchMoodTransactionsExcel,
} from "@/api/Reports";
/* eslint-disable */
export default {
  props: {
    selected: {
      required: false,
      type: Object,
    },
  },
  name: "BranchMoodReport",
  components: {
    PaginationDefault,
    GlobalFilter,
  },
  data() {
    return {
      moodTransactions: [],
      totalDataRow: 0,
      rawTableOptions: {},
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      isFilterActive: false,
      filterOptions: [
        "defaultTimeRange",
        "dateRange",
        "timeRange",
        "daysOfWeek",
      ],
      filterOptionNames: ["Zaman Aralığı", "Tarih", "Zaman", "Gün"],
      filterChips: [],
    };
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getExcel() {
      if (!this.selected) {
        return;
      }
      GetBranchMoodTransactionsExcel(this.tableOptions, this.rawTableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Mood Kayıtları" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.rawTableOptions = {
        branch: null,
        type: null,
        customer: null,
        product: null,
      };
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        daysOfWeek: null,
        defaultTimeRange:
          this.$now().getHours() >= 0 && this.$now().getHours() <= 2
            ? {
                name: "Yesterday",
                id: 0,
                dName: "Dün",
              }
            : {
                name: "Today",
                id: 1,
                dName: "Bugün",
              },
        timeRange: {
          startTime: null,
          endTime: null,
        },
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
      else this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getBranchMoodTransactions() {
      if (!this.selected) {
        return;
      }
      GetBranchMoodTransactions(this.tableOptions, this.rawTableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.moodTransactions = res.data.items;
            this.totalDataRow = res.data.totalCount;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hata : " + res.status,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Mood Kayıtları Yüklenemedi ! ",
          });
        });
    },
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getBranchMoodTransactions();
        });
      },
    },
    selected(val) {
      if (val) {
        this.saveOptions(
          {
            dateRange: val.dateRange,
            defaultTimeRange: val.defaultTimeRange,
            timeRange: val.timeRange,
            daysOfWeek: val.daysOfWeek,
            sortBy: "Created",
            sortDirection: "desc",
            pageIndex: 0,
          },
          []
        );
        this.currentPage = this.tableOptions.pageIndex;
        this.rawTableOptions.type = val.type;
        this.rawTableOptions.branch = val.branch;
        this.rawTableOptions.product = val.product;
        this.rawTableOptions.customer = val.customer;
        this.getBranchMoodTransactions();
      }
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
  created() {
    //this.clearFilter();
    // if (!this.$isCenterBranch()) {
    //   let branchPropIndex = this.filterOptions.indexOf("branch");
    //   this.filterOptions.splice(branchPropIndex, 1);
    //   this.filterOptionNames.splice(branchPropIndex, 1);
    //   delete this.tableOptions["branch"];
    // }
  },
};
</script>

<style scoped></style>
